export default "__VITE_ASSET__BLWVjJBe__"